import { logHelper } from "@qdabra/forms-shared/helpers";
import { LOG_SOURCE_FORMSVIEWER } from "../constants.logging";

const LOG_LEVEL_ERROR = 1;
const LOG_LEVEL_WARNING = 2;
const LOG_LEVEL_INFO = 3;
const LOG_LEVEL_VERBOSE = 4;

const logLevelStringToLevel = (levelString) => {
    switch (levelString) {
        case 'error':
            return LOG_LEVEL_ERROR;
        case 'warning':
            return LOG_LEVEL_WARNING;
        case 'info':
        case '':
        case null:
            return LOG_LEVEL_INFO;
        case 'verbose':
            return LOG_LEVEL_VERBOSE;
        default:
            throw new Error('Unknown log level: ' + levelString);
    }
}

const makeLogHelper = (api, { consoleLogLevel = LOG_LEVEL_INFO } = {}) => {
    const helper = logHelper(api, LOG_SOURCE_FORMSVIEWER);

    const logVerbose = (message) => {
        if (consoleLogLevel >= LOG_LEVEL_VERBOSE) {
            console.info(new Date(), message);
        }
    }

    const logInfo = (message) => {
        if (consoleLogLevel >= LOG_LEVEL_INFO) {
            console.log(new Date(), message);
        }
    }

    const logError = (description, error) => {
        console.error(new Date(), description, error);

        helper.logClientError(description, error);
    };

    return { logError, logInfo, logVerbose };
};

export {
    makeLogHelper,
    logLevelStringToLevel,
    LOG_LEVEL_ERROR,
    LOG_LEVEL_WARNING,
    LOG_LEVEL_INFO,
    LOG_LEVEL_VERBOSE,
};